import React from 'react';
import { extractNumericRate } from '../../utils';
import { useCurrentModule } from '../ModuleProvider';
import { useIsCurrentCycle } from '../../hooks/useIsCurrentCycle';
import { CycleSelectorBadgeUi } from './CycleSelectorBadgeUi';
export const CycleSelectorBadge = _ref => {
  var _savings$fixedAmount;
  let {
    productId,
    cycleId,
    isMobile = false
  } = _ref;
  const module = useCurrentModule();
  const {
    Trans
  } = module.internals.useTranslations();
  const {
    data: product
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchProduct({
    productId
  }, Boolean(productId));
  const {
    data: discountData
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOfferingDiscount({});
  const {
    data: cyclePricingData
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchCyclePricing({
    productId,
    cycleId
  }, Boolean(productId && cycleId));
  const {
    cyclePricing
  } = cyclePricingData ?? {};
  const {
    savings
  } = cyclePricing ?? {};
  const {
    salePerCycle
  } = product ?? {};
  const {
    discount,
    hasSale
  } = discountData ?? {};
  const {
    isCurrentCycle
  } = useIsCurrentCycle(cycleId);
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const isHideCycleSavingsFromCurrentCycleEnabled = experiments.isEnabled('specs.premium.EclipseHideCycleSavingsFromCurrentCycle');
  if (salePerCycle != null && salePerCycle[cycleId]) {
    return /*#__PURE__*/React.createElement(CycleSelectorBadgeUi, {
      isMobile: isMobile,
      text: /*#__PURE__*/React.createElement(Trans, {
        i18nKey: isMobile ? 'cycle_entry.mobile.sale_badge' : 'cycle_entry.sale_badge_discount_only',
        values: {
          // TODO: Ask from the platform to return the rate without the % symbol
          discount: discount != null && discount.rate ? extractNumericRate(discount.rate) : ''
        },
        components: {
          1: /*#__PURE__*/React.createElement(React.Fragment, null)
        }
      })
    });
  }
  if (savings != null && (_savings$fixedAmount = savings.fixedAmount) != null && _savings$fixedAmount.amount && !hasSale && (!isCurrentCycle || !isHideCycleSavingsFromCurrentCycleEnabled)) {
    return /*#__PURE__*/React.createElement(CycleSelectorBadgeUi, {
      isMobile: isMobile,
      text: /*#__PURE__*/React.createElement(Trans, {
        i18nKey: "cycle_entry.cycle_discount",
        values: {
          discount: savings.fixedAmount.formattedAmount
        },
        components: {
          1: /*#__PURE__*/React.createElement(React.Fragment, null)
        }
      })
    });
  }
  return null;
};
//# sourceMappingURL=CycleSelectorBadge.js.map